// src/services/kokam/temporalKokamInscribirService.js

import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/kokam/inscribir";

/**
 * @param {File} file
 */

export const subirExcelInscritos = async (file) => {
  try {
    const formData = new FormData();
    formData.append("archivo", file);

    const response = await axios.post(
      `${baseUrl}${endpoint}/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error("Error subiendo Excel de inscritos:", error);
    throw error;
  }
};